export const SEARCH_ASSET_PERFORMANCE_ACTIVATION = "SEARCH_ASSET_PERFORMANCE_ACTIVATION";
export const SEARCH_ASSET_PERFORMANCE_ACTIVATION_SUCCESS = "SEARCH_ASSET_PERFORMANCE_ACTIVATION_SUCCESS";
export const SEARCH_ASSET_PERFORMANCE_ACTIVATION_FAILED = "SEARCH_ASSET_PERFORMANCE_ACTIVATION_FAILED";
export const RESET_ASSET_PERFORMANCE_ACTIVATION_REPORT = "RESET_ASSET_PERFORMANCE_ACTIVATION_REPORT";
